var _defs, _path, _g, _g2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    zoomAndPan: "magnify",
    viewBox: "0 0 33.75 33.749998",
    height: 45,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a0e4ef88d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27.210938 0 L 33.5 0 L 33.5 33.5 L 27.210938 33.5 Z M 27.210938 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7bc704a520"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 30.15625 L 33.5 30.15625 L 33.5 33.5 L 0 33.5 Z M 0 30.15625 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M -1.476562 -0.4375 L 26.40625 -0.4375 C 27.351562 -0.4375 28.203125 0.414062 28.203125 1.359375 L 28.203125 29.242188 C 28.203125 30.1875 27.351562 31.039062 26.40625 31.039062 L -1.476562 31.039062 C -2.421875 31.039062 -3.273438 30.1875 -3.273438 29.242188 L -3.273438 1.359375 C -3.273438 0.414062 -2.421875 -0.4375 -1.476562 -0.4375 Z M 19.078125 17.234375 L 23.425781 17.234375 L 23.617188 13.078125 L 19.078125 13.078125 L 19.078125 10.007812 C 19.078125 8.824219 19.316406 8.164062 20.828125 8.164062 L 23.472656 8.164062 L 23.570312 4.285156 C 23.570312 4.285156 22.386719 4.097656 20.6875 4.097656 C 16.527344 4.097656 14.683594 6.699219 14.683594 9.484375 L 14.683594 13.078125 L 11.613281 13.078125 L 11.613281 17.234375 L 14.683594 17.234375 L 14.683594 28.765625 L 19.078125 28.765625 Z M 19.078125 17.234375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a0e4ef88d8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 27.210938 0 L 36.332031 0 L 36.332031 33.488281 L 27.210938 33.488281 Z M 27.210938 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7bc704a520)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 33.5 30.15625 L 33.5 34.546875 L -0.0117188 34.546875 L -0.0117188 30.15625 Z M 33.5 30.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a0e0db6b5535e18fcc24aa6d2f697526.svg";
export { ForwardRef as ReactComponent };